var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4A14E"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#279FC9"
    },
    d: "M279.863,100.488H30.362c-8.981,0-16.261-7.28-16.261-16.261V35.372 c0-8.981,7.28-16.261,16.261-16.261h249.502V100.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34ABE0"
    },
    d: "M279.356,100.488H47.572c-9.383,0-16.99-7.607-16.99-16.99V36.101c0-9.383,7.607-16.99,16.99-16.99 h231.783c9.383,0,16.99,7.607,16.99,16.99v47.397C296.346,92.881,288.739,100.488,279.356,100.488z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.428,
    y: 42.361,
    style: {
      fill: "#5C5E70"
    },
    width: 242.071,
    height: 34.876
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9EED7"
    },
    d: "M290.598,58.254H88.597H46.363c23.325,0,42.234,18.908,42.234,42.234v183.108 c0,22.806,18.48,41.265,41.265,41.265c11.413,0,53.516,0.002,53.516,0.002s19.853-9.124,19.853-20.517 c0-11.392,9.261,2.254,16.718-5.224c7.478-7.457,109.816,3.847,121.208,3.847l-8.327-60.64V100.488 C332.831,77.163,313.923,58.254,290.598,58.254z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5E70"
    },
    d: "M291.06,151.992H130.367c-5.689,0-10.301-4.612-10.301-10.301l0,0 c0-5.689,4.612-10.301,10.301-10.301h160.694c5.689,0,10.301,4.612,10.301,10.301l0,0 C301.362,147.381,296.75,151.992,291.06,151.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5E70"
    },
    d: "M291.06,197.902H130.367c-5.689,0-10.301-4.612-10.301-10.301l0,0 c0-5.689,4.612-10.301,10.301-10.301h160.694c5.689,0,10.301,4.612,10.301,10.301l0,0 C301.362,193.289,296.75,197.902,291.06,197.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5E70"
    },
    d: "M291.06,243.81H130.367c-5.689,0-10.301-4.612-10.301-10.301l0,0 c0-5.689,4.612-10.301,10.301-10.301h160.694c5.689,0,10.301,4.612,10.301,10.301l0,0C301.362,239.198,296.75,243.81,291.06,243.81 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5E70"
    },
    d: "M291.06,289.719H130.367c-5.689,0-10.301-4.612-10.301-10.301l0,0 c0-5.689,4.612-10.301,10.301-10.301h160.694c5.689,0,10.301,4.612,10.301,10.301l0,0 C301.362,285.107,296.75,289.719,291.06,289.719z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6C8B0"
    },
    d: "M380.863,283.599l-54.335,41.264H129.869c11.4,0,21.715-4.616,29.194-12.07 c7.453-7.479,12.07-17.796,12.07-29.194c0-11.399,4.616-21.715,12.07-29.194c7.479-7.453,17.796-12.07,29.194-12.07 s112.952,4.616,120.432,12.07C340.285,261.884,380.863,272.2,380.863,283.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9EED7"
    },
    d: "M497.894,283.596v56.424c-7.743,22.288-18.474,43.175-31.723,62.182 c-3.135,4.504-6.416,8.903-9.832,13.187c-7.126,8.944-14.838,17.408-23.082,25.307c-7.659,7.356-15.778,14.242-24.294,20.605 c-12.999,9.697-26.937,18.181-41.671,25.307c-19.352,9.352-40.051,16.342-61.733,20.595C289.531,510.349,272.959,512,256,512 c-0.784,0-1.557,0-2.341-0.01V283.596c0-5.089-0.92-9.968-2.612-14.482c-2.09-5.569-5.339-10.574-9.456-14.712 c-4.984-4.974-11.222-8.673-18.202-10.595c-3.176-0.867-6.499-1.369-9.927-1.463c-0.355-0.01-0.711-0.01-1.066-0.01h244.234 c11.41,0,21.713,4.608,29.184,12.069C493.275,261.883,497.894,272.206,497.894,283.596z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5E70"
    },
    d: "M455.879,323.571H295.177c-5.687,0-10.297-4.61-10.297-10.297v-0.007 c0-5.687,4.61-10.297,10.297-10.297h160.701c5.687,0,10.297,4.61,10.297,10.297v0.007 C466.176,318.961,461.566,323.571,455.879,323.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5E70"
    },
    d: "M455.879,369.481H295.177c-5.687,0-10.297-4.61-10.297-10.297v-0.007 c0-5.687,4.61-10.297,10.297-10.297h160.701c5.687,0,10.297,4.61,10.297,10.297v0.007 C466.176,364.87,461.566,369.481,455.879,369.481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5E70"
    },
    d: "M466.171,394.783v7.419c-3.135,4.504-6.416,8.903-9.832,13.187h-161.16 c-5.687,0-10.297-4.61-10.297-10.297v-0.01c0-5.687,4.61-10.297,10.297-10.297L466.171,394.783L466.171,394.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5E70"
    },
    d: "M433.257,440.696c-7.659,7.356-15.778,14.242-24.294,20.605H295.178 c-5.687,0-10.297-4.61-10.297-10.297v-0.01c0-5.687,4.61-10.297,10.297-10.297L433.257,440.696L433.257,440.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C5E70"
    },
    d: "M367.292,486.609c-19.352,9.352-40.051,16.342-61.733,20.595h-10.381 c-5.687,0-10.297-4.61-10.297-10.297l0,0c0-5.687,4.61-10.297,10.297-10.297L367.292,486.609L367.292,486.609z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.84fd6c97c72ed99ae64149b70760a42b.svg";
export { ForwardRef as ReactComponent };